import { AccountFilters } from "../types";

export const prepareFilters = (data?: AccountFilters) => {
  if (!data) return [];

  const keys = Object.keys(data);

  return [
    ...keys
      .filter((key) => data[key as keyof AccountFilters].length > 0)
      .map((key: string) => {
        return {
          placeholder:
            key === "buyer_journey"
              ? "Buyer's Journey"
              : key.charAt(0).toUpperCase() + key.slice(1),
          query: key,
          items: data[key as keyof AccountFilters],
        };
      }),
  ];
};
